import { jsx as _jsx } from "react/jsx-runtime";
import { Progress as ProgressPrimitive } from "radix-ui";
import { cn } from "../../lib/cn";
/**
 * The brand's `.seg`: a 4px track on `--lg-surface-3` with a pink fill and a
 * 2px radius. It is a progress bar and, laid out in a row, the step indicator.
 *
 * Radix supplies `role="progressbar"` and the aria-value attributes, including
 * the indeterminate case, which is the whole reason to use it over a div.
 */
export function Progress({ className, value = null, ...props }) {
    return (_jsx(ProgressPrimitive.Root, { "data-slot": "progress", value: value, className: cn("lg:relative lg:h-1 lg:w-full lg:overflow-hidden lg:rounded-xs lg:bg-brand-surface3", className), ...props, children: _jsx(ProgressPrimitive.Indicator, { "data-slot": "progress-indicator", className: cn("lg:h-full lg:w-full lg:flex-1 lg:rounded-xs lg:bg-primary lg:transition-transform", value === null && "lg:animate-pulse"), style: { transform: `translateX(-${String(100 - (value ?? 100))}%)` } }) }));
}
//# sourceMappingURL=progress.js.map